import { AddressExchangeToken } from '@/api'

export default {
  namespaced: true,

  state: ({
    // currentToken: null
  }),

  mutations: {
    // setCurrentToken(state, payload) {
    //   state.currentToken = payload
    // } 
  },

  getters: {},

  actions: {
    fetch(context, payload) {
      return AddressExchangeToken.fetch({ targetID: payload }).then(res => {
        console.log('on model' + res)
        console.log(res)
        console.log(res.data.address_exchange_token)
        return res.data.address_exchange_token
      })
    },

    create(context, payload) {
      console.log(payload)
      return AddressExchangeToken.create({ addressCategoryID: payload }).then(res => {
        console.log('on store')
        console.log(res)
        // commit('setCurrentToken', res.data.address_exchange_token)
        return res.data.address_exchange_token
      })
    },

    exchange(context, payload) {
      return AddressExchangeToken.exchange(payload).then(res => {
        console.log(res)
        return res.data.result
      })
    }
  },
}